import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {LocaleService} from "./services/locale.service";
import {EpaasHelperService} from "./services/epaas-helper.service";
import {VersionCheckService} from "./services/version-check.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false
})
export class AppComponent {
  constructor(
    private readonly localeService: LocaleService,
    private readonly cdr: ChangeDetectorRef,
    private readonly epaasHelperService: EpaasHelperService,
    private readonly versionCheckService: VersionCheckService
  ) {
    this.localeService.localeChanged.subscribe({
      next: () => {
        this.epaasHelperService.changeLocale(this.localeService.currentLocale);
        this.cdr.markForCheck();
      }
    });

    this.versionCheckService.initVersionCheck()

    this.epaasHelperService.initalizeEpaas();
  }
}
